import styled from 'styled-components'

/** The tile thumbnail expanded as the popup's visual anchor. */
export const HeroImage = styled.img`
	width: 100%;
	max-height: 280px;
	object-fit: cover;
	border-radius: 10px;
	display: block;
`

export const DetailStack = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	margin-top: 1rem;
`

export const CategoryBadge = styled.span`
	align-self: flex-start;
	background: #fff7ed;
	color: #c2410c;
	font-size: 0.8rem;
	font-weight: 600;
	padding: 0.25rem 0.625rem;
	border-radius: 6px;
`
